import { loadFrames } from '../actions/frames'
import { loadPhotos } from '../actions/photos'
import { loadProducts } from '../actions/products'
import { loadWallpapers } from '../actions/wallpapers'
import {
  TOGGLE_MODAL_FRAMES,
  TOGGLE_NAVIGATION_FRAMES,
  TOGGLE_NAVIGATION_PHOTOS,
  TOGGLE_NAVIGATION_PRODUCTS,
  TOGGLE_NAVIGATION_WALLS,
  TOGGLE_SIDEBAR,
} from './../constants/sidebarActions'

export const toggleSidebar = () => ({ type: TOGGLE_SIDEBAR })

export const toggleNavigationPhotos = getPhotos => dispatch => {
  dispatch({ type: TOGGLE_NAVIGATION_PHOTOS })
  dispatch(loadPhotos(getPhotos))
}
export const toggleNavigationWalls = getWallpapers => dispatch => {
  dispatch({ type: TOGGLE_NAVIGATION_WALLS })
  dispatch(loadWallpapers(getWallpapers))
}
export const toggleNavigationProducts = getProducts => dispatch => {
  dispatch({ type: TOGGLE_NAVIGATION_PRODUCTS })
  dispatch(loadProducts(getProducts))
}

export const toggleNavigationFrames = getFrames => dispatch => {
  dispatch({ type: TOGGLE_NAVIGATION_FRAMES })
  dispatch(loadFrames(getFrames))
}

export const toggleFramesModal = src => ({
  type: TOGGLE_MODAL_FRAMES,
  src,
})



// WEBPACK FOOTER //
// ./src/actions/sidebar.js